// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"05d1037d","453":"926f0775","455":"0110e430","821":"454a346b","977":"d797c24e"}[chunkId] + ".chunk.js";
};